export const ENV = {
    mode: 'Production',
    url : 'https://apiv2.airmont.com',
    api : 'https://apiv2.airmont.com',
    version : '1.3.2',
    isBrowser: true
}


// WEBPACK FOOTER //
// ./src/environments/environment.dev.ts